/* PETAVIS katalog motoru
   assets/pv-catalog.json'u okur, ızgara ve ürün sayfası çizer.
   Gerçek Shopify ürünü yok — bu görsel katalog.

   Mount noktaları:
     <div data-pv-catalog data-cat="Best Sellers" data-cols="4" data-initial="8" data-limit="24">
     <div data-pv-catalog-detail>          -> ?p=<handle> okur
     <div data-pv-catalog-chips data-cats="Dog Beds,Dog Toys">
*/
(function () {
  'use strict';

  var DATA_URL = window.PV_CATALOG_URL || null;
  var ASSET_BASE = window.PV_ASSET_BASE || '';
  var cache = null;

  function money(n) {
    return '$' + Number(n).toFixed(2);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function imgUrl(name) {
    return ASSET_BASE ? ASSET_BASE.replace('__NAME__', name) : name;
  }

  function load() {
    if (cache) return Promise.resolve(cache);
    if (!DATA_URL) return Promise.reject(new Error('katalog adresi yok'));
    return fetch(DATA_URL, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('katalog yüklenemedi: ' + r.status);
        return r.json();
      })
      .then(function (j) {
        cache = j;
        return j;
      });
  }

  /* ------------------------------------------------------------ renk noktası */

  var COLOR_MAP = {
    'natural white': '#f2ece2',
    'fruit green': '#8bc34a',
    'turquoise green': '#3fc1c9',
    'rose red': '#e0245e',
    khaki: '#c3b091',
    beige: '#e8dcc8',
    coffee: '#6f4e37',
    'navy blue': '#1f3864',
    grey: '#9aa0a6',
    gray: '#9aa0a6',
    purple: '#8e44ad',
    orange: '#f39c12',
    brown: '#795548',
    pink: '#f48fb1',
    blue: '#3b82f6',
    green: '#22a06b',
    yellow: '#f7c948',
    red: '#e53935',
    black: '#1c1c1c',
    white: '#ffffff',
    silver: '#c0c0c0',
    gold: '#d4af37',
  };

  function colorDot(name) {
    var k = String(name).toLowerCase().trim();
    if (COLOR_MAP[k]) return COLOR_MAP[k];
    for (var key in COLOR_MAP) if (k.indexOf(key) !== -1) return COLOR_MAP[key];
    return '#d9d9d9';
  }

  /* ------------------------------------------------------------------ kartlar */

  // Beyaz zeminli kart kopyası: `pv-w-<dosya>`. Ürün görselinin kendisi krem
  // kalır; sadece beyaz isteyen bölümler bu kopyayı kullanır. Kopya yoksa
  // onerror ile normal dosyaya düşer, yani eksik varyant kartı bozmaz.
  function whiteName(n) {
    return n ? 'pv-w-' + n : n;
  }

  function cardHTML(p, white) {
    // card_image varsa onu kullan (model fotoğrafı), yoksa ilk görsel
    var main = p.card_image || (p.images && p.images[0]);
    var img = main ? imgUrl(white ? whiteName(main) : main) : '';
    var imgFb = white && main ? imgUrl(main) : '';
    var alt = (p.images || []).filter(function (n) { return n !== main; })[0];
    var img2 = alt ? imgUrl(white ? whiteName(alt) : alt) : '';
    var img2Fb = white && alt ? imgUrl(alt) : '';
    var url = catalogUrl(p.handle);
    var off = '';
    if (p.compare_at && p.compare_at > p.price) {
      off = '<span class="pv-badge pv-badge--sale">&minus;' + Math.round(((p.compare_at - p.price) / p.compare_at) * 100) + '%</span>';
    }

    var swatches = '';
    if (p.colors && p.colors.length) {
      swatches = '<div class="pv-card__swatches">';
      p.colors.slice(0, 5).forEach(function (c) {
        swatches += '<span class="pv-swatch" style="background:' + colorDot(c) + '" title="' + esc(c) + '"></span>';
      });
      if (p.colors.length > 5) swatches += '<span class="pv-card__more">+' + (p.colors.length - 5) + '</span>';
      swatches += '</div>';
    }

    return (
      '<div class="pv-card">' +
      '<a class="pv-card__media" href="' + url + '" aria-label="' + esc(p.title) + '">' +
      (img ? '<img class="pv-card__img--main" src="' + img + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600"' +
        (imgFb ? ' onerror="this.onerror=null;this.src=\'' + imgFb + '\'"' : '') + '>' : '') +
      (img2 ? '<img class="pv-card__img--alt" src="' + img2 + '" alt="" loading="lazy" aria-hidden="true" width="600" height="600"' +
        (img2Fb ? ' onerror="this.onerror=null;this.src=\'' + img2Fb + '\'"' : '') + '>' : '') +
      '</a>' +
      '<div class="pv-card__badges">' + off + '</div>' +
      '<button type="button" class="pv-card__wish" data-pv-wish="' + esc(p.handle) + '" aria-pressed="false" aria-label="Add to wishlist">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 5.6a5.2 5.2 0 0 0-7.4 0L12 7l-1.4-1.4a5.2 5.2 0 0 0-7.4 7.4l1.4 1.4L12 22l7.4-7.6 1.4-1.4a5.2 5.2 0 0 0 0-7.4Z"/></svg>' +
      '</button>' +
      '<button type="button" class="pv-card__quickadd" data-pv-add ' +
      'data-handle="' + esc(p.handle) + '" data-title="' + esc(p.title) + '" ' +
      'data-price="' + p.price + '" data-image="' + esc(main || '') + '" ' +
      'data-color="' + esc((p.colors && p.colors[0]) || '') + '" ' +
      'data-size="' + esc((p.sizes && p.sizes[0]) || '') + '">Add to cart</button>' +
      '<h3 class="pv-card__title"><a href="' + url + '">' + esc(p.title) + '</a></h3>' +
      '<div class="pv-card__price">' +
      (p.compare_at && p.compare_at > p.price
        ? '<ins>' + money(p.price) + '</ins><del>' + money(p.compare_at) + '</del>'
        : money(p.price)) +
      '</div>' +
      swatches +
      '</div>'
    );
  }

  function catalogUrl(handle) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return base + 'collections/all?p=' + encodeURIComponent(handle);
  }

  /* -------------------------------------------------------------- ızgara mount */

  function mountGrid(el, items) {
    var cat = el.getAttribute('data-cat');
    var cols = parseInt(el.getAttribute('data-cols') || '4', 10);
    var initial = parseInt(el.getAttribute('data-initial') || '8', 10);
    var limit = parseInt(el.getAttribute('data-limit') || '0', 10);

    var list = items.slice();
    if (cat) {
      list = list.filter(function (p) {
        return (p.categories || []).some(function (c) {
          return c.toLowerCase() === cat.toLowerCase();
        });
      });
    }
    if (limit > 0) list = list.slice(0, limit);

    if (!list.length) {
      el.innerHTML = '';
      return;
    }

    // az ürün varsa ızgara sola yaslanmasın
    var useCols = Math.min(cols, Math.max(1, Math.min(list.length, initial)));
    var html = '<div class="pv-products__grid pv-products__grid--center" style="--pv-cols:' + useCols + '">';
    list.forEach(function (p, i) {
      html += '<div' + (i >= initial ? ' hidden data-pv-hidden="true"' : '') + '>' + cardHTML(p) + '</div>';
    });
    html += '</div>';

    if (list.length > initial) {
      html += '<div class="pv-products__foot"><button type="button" class="pv-btn pv-btn--ghost" data-pv-more>Load more</button></div>';
    }
    el.innerHTML = html;

    var btn = el.querySelector('[data-pv-more]');
    if (btn) {
      btn.addEventListener('click', function () {
        var hid = el.querySelectorAll('[data-pv-hidden="true"]');
        Array.prototype.slice.call(hid, 0, cols * 2).forEach(function (n) {
          n.hidden = false;
          n.removeAttribute('data-pv-hidden');
        });
        if (!el.querySelectorAll('[data-pv-hidden="true"]').length) btn.hidden = true;
      });
    }
  }

  /* ------------------------------------------------------- koleksiyon çipleri */

  function mountChips(el, items) {
    var cats = (el.getAttribute('data-cats') || '').split(',').map(function (s) {
      return s.trim();
    }).filter(Boolean);
    if (!cats.length) return;

    // Ürün sayacı tema ayarından gelir. Kapalıyken "2 items" gibi rakamlar
    // basılıp kategoriler boş gösteriliyordu — ayar artık dikkate alınıyor.
    var showCount = el.getAttribute('data-show-count') === '1';

    var html = '<div class="pv-chips">';
    cats.forEach(function (c) {
      var inCat = items.filter(function (p) {
        return (p.categories || []).some(function (x) {
          return x.toLowerCase() === c.toLowerCase();
        });
      });
      if (!inCat.length) return;
      // Marka kitindeki kategori kartı varsa onu kullan (pv-cat-<slug>.jpg),
      // yoksa kategorideki ilk ürünün görseline düş.
      var slugCat = c.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      var img = imgUrl('pv-cat-' + slugCat + '.jpg');
      var fallback = inCat[0].images && inCat[0].images[0] ? imgUrl(inCat[0].images[0]) : '';
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      html +=
        '<a class="pv-chip" href="' + base + 'collections/all?c=' + encodeURIComponent(c) + '">' +
        '<span class="pv-chip__media">' +
        '<img src="' + img + '" alt="' + esc(c) + '" loading="lazy" width="200" height="200"' +
        (fallback ? ' onerror="this.onerror=null;this.src=\'' + fallback + '\'"' : '') + '>' +
        '</span>' +
        '<span class="pv-chip__name">' + esc(c) + '</span>' +
        (showCount ? '<span class="pv-chip__count">' + inCat.length + ' items</span>' : '') +
        '</a>';
    });
    html += '</div>';
    el.innerHTML = html;
  }

  /* -------------------------------- büyük görsel sekmeleri + ürün ızgarası */

  function mountTiles(el, items) {
    var cats = (el.getAttribute('data-cats') || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
    if (!cats.length) return;

    var cols = parseInt(el.getAttribute('data-cols') || '4', 10);
    var count = parseInt(el.getAttribute('data-count') || '4', 10);

    // Elle seçilmiş kapaklar: "Kategori:dosya.jpg, Kategori2:dosya2.jpg"
    // Model fotoğrafı (hayvanın üstünde) düz ürün çekiminden çok daha iyi duruyor.
    var overrides = {};
    (el.getAttribute('data-covers') || '').split(',').forEach(function (pair) {
      var i = pair.indexOf(':');
      if (i < 1) return;
      overrides[pair.slice(0, i).trim().toLowerCase()] = pair.slice(i + 1).trim();
    });

    // her kategori için kapak görseli: elle seçim > marka kartı > ilk ürün
    function coverFor(c) {
      var slugCat = c.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      var inCat = items.filter(function (p) {
        return (p.categories || []).some(function (x) { return x.toLowerCase() === c.toLowerCase(); });
      });
      var manual = overrides[c.toLowerCase()];
      return {
        brand: manual ? imgUrl(manual) : imgUrl('pv-cat-' + slugCat + '.jpg'),
        fallback: inCat[0] && inCat[0].images && inCat[0].images[0] ? imgUrl(inCat[0].images[0]) : '',
        list: inCat
      };
    }

    var covers = cats.map(coverFor);
    // Sadece bu bölümün kartları beyaz zeminli kopyayı kullanır (anasayfa görünümü).
    var whiteCards = el.getAttribute('data-white-cards') === 'true';

    var html = '<div class="pv-tiles" role="tablist">';
    cats.forEach(function (c, i) {
      var cv = covers[i];
      html +=
        '<button type="button" class="pv-tile" role="tab" aria-selected="' + (i === 0 ? 'true' : 'false') + '" data-i="' + i + '">' +
        '<img src="' + (cv.brand || cv.fallback) + '" alt="' + esc(c) + '" loading="lazy" width="600" height="600"' +
        (cv.fallback ? ' onerror="this.onerror=null;this.src=\'' + cv.fallback + '\'"' : '') + '>' +
        '<span class="pv-tile__label">' + esc(c) + '</span></button>';
    });
    html += '</div><div class="pv-tiles__panel"></div>';
    el.innerHTML = html;

    var panel = el.querySelector('.pv-tiles__panel');

    function show(i) {
      el.querySelectorAll('.pv-tile').forEach(function (t) {
        t.setAttribute('aria-selected', String(parseInt(t.getAttribute('data-i'), 10) === i));
      });
      var list = covers[i].list.slice(0, count);
      if (!list.length) {
        panel.innerHTML = '<p class="pv-subtitle" style="text-align:center">Nothing here yet.</p>';
        return;
      }
      // Ürün sayısı sütun sayısından azsa ızgara sola yaslı kalıyordu —
      // sütunu ürüne eşitleyip ortalıyoruz.
      var useCols = Math.min(cols, list.length);
      panel.innerHTML =
        '<div class="pv-head"><h3 class="pv-title" style="font-size:clamp(20px,2.4vw,28px)">' + esc(cats[i]) + '</h3></div>' +
        '<div class="pv-products__grid pv-products__grid--center" style="--pv-cols:' + useCols + '">' +
        list.map(function (p) { return '<div>' + cardHTML(p, whiteCards) + '</div>'; }).join('') +
        '</div>' +
        '<div class="pv-products__foot"><a class="pv-btn pv-btn--ghost" href="' +
        ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') +
        'collections/all?c=' + encodeURIComponent(cats[i]) + '">View all ' + esc(cats[i]) + '</a></div>';
      if (window.PVBoot) window.PVBoot();
    }

    el.querySelectorAll('.pv-tile').forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-i'), 10)); });
    });
    show(0);
  }

  /* --------------------------------------------------------- ürün detay sayfası */

  function mountDetail(el, items) {
    var params = new URLSearchParams(location.search);
    var handle = params.get('p');
    var catFilter = params.get('c');

    if (!handle) {
      // ürün seçilmemiş -> tüm katalog / kategori / indirim süzgeci
      var saleOnly = params.get('sale') === '1';
      var list = items;
      var heading = 'All products';

      if (saleOnly) {
        list = items.filter(function (p) {
          return p.compare_at && p.compare_at > p.price;
        });
        heading = 'Sale';
      } else if (catFilter) {
        list = items.filter(function (p) {
          return (p.categories || []).some(function (x) {
            return x.toLowerCase() === catFilter.toLowerCase();
          });
        });
        heading = catFilter;
      }

      document.title = heading + ' – ' + (window.PV_SHOP_NAME || 'Petavis');

      var body =
        '<div class="pv-container pv-section">' +
        '<div class="pv-head"><h1 class="pv-title">' + esc(heading) + '</h1>' +
        '<p class="pv-subtitle">' + list.length + (list.length === 1 ? ' product' : ' products') + '</p></div>';

      if (!list.length) {
        // Boş kategori de olsa buton kırık görünmesin — açık bir mesaj göster.
        body +=
          '<div style="text-align:center;padding:40px 0">' +
          '<p class="pv-subtitle" style="margin-inline:auto">Nothing here yet. New products are added regularly.</p>' +
          '<p style="margin-top:22px"><a class="pv-btn" href="' + ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'collections/all">Browse all products</a></p></div>';
      } else {
        body += '<div data-pv-catalog data-cols="4" data-initial="12"></div>';
      }
      el.innerHTML = body + '</div>';

      var g = el.querySelector('[data-pv-catalog]');
      if (g) {
        if (saleOnly) {
          // kategori süzgeci yok; doğrudan indirimli listeyi ver
          mountGrid(g, list);
        } else {
          if (catFilter) g.setAttribute('data-cat', catFilter);
          mountGrid(g, items);
        }
      }
      if (window.PVBoot) window.PVBoot();
      return;
    }

    var p = items.filter(function (x) {
      return x.handle === handle;
    })[0];

    if (!p) {
      el.innerHTML =
        '<div class="pv-container pv-section" style="text-align:center">' +
        '<h1 class="pv-title">Product not found</h1>' +
        '<p class="pv-subtitle" style="margin-inline:auto">This product may have been removed.</p>' +
        '<p style="margin-top:24px"><a class="pv-btn" href="' + catalogUrl('').replace('?p=', '') + '">Back to shop</a></p></div>';
      return;
    }

    document.title = p.title + ' – ' + (window.PV_SHOP_NAME || 'Petavis');

    var gallery = p.images || [];
    var thumbs = gallery
      .map(function (n, i) {
        return (
          '<button type="button" class="pv-pdp__thumb' + (i === 0 ? ' is-active' : '') + '" data-i="' + i + '">' +
          '<img src="' + imgUrl(n) + '" alt="" loading="lazy" width="120" height="120"></button>'
        );
      })
      .join('');

    var colorHTML = '';
    if (p.colors && p.colors.length) {
      colorHTML =
        '<div class="pv-pdp__opt"><span class="pv-pdp__optlabel">Color: <b data-pv-colorname>' + esc(p.colors[0]) + '</b></span><div class="pv-pdp__colors">' +
        p.colors
          .map(function (c, i) {
            return (
              '<button type="button" class="pv-pdp__color' + (i === 0 ? ' is-active' : '') + '" data-color="' + esc(c) + '" ' +
              'style="background:' + colorDot(c) + '" title="' + esc(c) + '" aria-label="' + esc(c) + '"></button>'
            );
          })
          .join('') +
        '</div></div>';
    }

    var sizeHTML = '';
    if (p.sizes && p.sizes.length) {
      sizeHTML =
        '<div class="pv-pdp__opt"><span class="pv-pdp__optlabel">Size</span><div class="pv-pdp__sizes">' +
        p.sizes
          .map(function (s, i) {
            return '<button type="button" class="pv-pdp__size' + (i === 0 ? ' is-active' : '') + '" data-size="' + esc(s) + '">' + esc(s) + '</button>';
          })
          .join('') +
        '</div></div>';
    }

    var feats = (p.description.features || [])
      .map(function (f) {
        return '<li>' + esc(f) + '</li>';
      })
      .join('');

    var related = items
      .filter(function (x) {
        return x.handle !== p.handle && x.type === p.type;
      })
      .slice(0, 4);

    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    el.innerHTML =
      '<div class="pv-container pv-section">' +
      '<nav class="pv-crumbs"><a href="' + base + '">Home</a> <span>/</span> ' +
      '<a href="' + base + 'collections/all?c=' + encodeURIComponent(p.categories[0] || '') + '">' + esc(p.categories[0] || 'Shop') + '</a> ' +
      '<span>/</span> <span>' + esc(p.title) + '</span></nav>' +

      '<div class="pv-pdp">' +
      '<div class="pv-pdp__media">' +
      '<div class="pv-pdp__main"><img src="' + (gallery[0] ? imgUrl(gallery[0]) : '') + '" alt="' + esc(p.title) + '" data-pv-main width="900" height="900"></div>' +
      (gallery.length > 1 ? '<div class="pv-pdp__thumbs">' + thumbs + '</div>' : '') +
      '</div>' +

      '<div class="pv-pdp__info">' +
      '<p class="pv-pdp__type">' + esc(p.type) + '</p>' +
      '<h1 class="pv-pdp__title">' + esc(p.title) + '</h1>' +
      '<div class="pv-pdp__price">' +
      (p.compare_at && p.compare_at > p.price
        ? '<ins>' + money(p.price) + '</ins><del>' + money(p.compare_at) + '</del>' +
          '<span class="pv-badge pv-badge--sale">Save ' + money(p.compare_at - p.price) + '</span>'
        : money(p.price)) +
      '</div>' +
      '<p class="pv-pdp__summary">' + esc(p.description.summary) + '</p>' +
      colorHTML +
      sizeHTML +
      '<div class="pv-pdp__buy">' +
      '<div class="pv-qty"><button type="button" data-q="-1" aria-label="Decrease">&minus;</button>' +
      '<input type="number" value="1" min="1" max="99" aria-label="Quantity" data-pv-qty><button type="button" data-q="1" aria-label="Increase">+</button></div>' +
      '<button type="button" class="pv-btn pv-pdp__add" data-pv-add>Add to cart</button>' +
      '</div>' +
      '<p class="pv-pdp__note" data-pv-addnote hidden></p>' +
      '<ul class="pv-pdp__feats">' + feats + '</ul>' +
      '<p class="pv-pdp__meta">SKU: ' + esc(p.sku || '—') + ' &nbsp;·&nbsp; ' + esc((p.categories || []).join(', ')) + '</p>' +
      '<p class="pv-pdp__ship">' + esc(p.description.note) + '</p>' +
      '</div></div>' +

      (related.length
        ? '<section class="pv-section"><div class="pv-head"><h2 class="pv-title">You may also like</h2></div>' +
          '<div class="pv-products__grid" style="--pv-cols:4">' +
          related.map(function (r) { return '<div>' + cardHTML(r) + '</div>'; }).join('') +
          '</div></section>'
        : '') +
      '</div>';

    wireDetail(el, p);
    if (window.PVBoot) window.PVBoot();
  }

  function wireDetail(el, p) {
    var main = el.querySelector('[data-pv-main]');
    var gallery = p.images || [];

    el.querySelectorAll('.pv-pdp__thumb').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = parseInt(b.getAttribute('data-i'), 10);
        if (main && gallery[i]) main.src = imgUrl(gallery[i]);
        el.querySelectorAll('.pv-pdp__thumb').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
      });
    });

    // renk seçimi -> o renge ait ilk görsele atla
    el.querySelectorAll('.pv-pdp__color').forEach(function (b) {
      b.addEventListener('click', function () {
        var c = b.getAttribute('data-color');
        el.querySelectorAll('.pv-pdp__color').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        var nameEl = el.querySelector('[data-pv-colorname]');
        if (nameEl) nameEl.textContent = c;

        // O renge ait fotoğraf yoksa (tedarikçi vermemiş olabilir) genel
        // görsele dön — tıklayınca hiçbir şey olmaması bozuk hissi veriyor.
        var imgs = (p.images_by_color || {})[c];
        var target = imgs && imgs.length ? imgs[0] : gallery[0];
        if (target && main) {
          main.src = imgUrl(target);
          var idx = gallery.indexOf(target);
          el.querySelectorAll('.pv-pdp__thumb').forEach(function (x) {
            x.classList.toggle('is-active', parseInt(x.getAttribute('data-i'), 10) === idx);
          });
        }
      });
    });

    el.querySelectorAll('.pv-pdp__size').forEach(function (b) {
      b.addEventListener('click', function () {
        el.querySelectorAll('.pv-pdp__size').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
      });
    });

    var qty = el.querySelector('[data-pv-qty]');
    el.querySelectorAll('[data-q]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = parseInt(b.getAttribute('data-q'), 10);
        var v = Math.min(99, Math.max(1, (parseInt(qty.value, 10) || 1) + d));
        qty.value = v;
      });
    });

    var add = el.querySelector('[data-pv-add]');
    if (add) {
      add.addEventListener('click', function () {
        if (!window.PVCart) return;
        var color = el.querySelector('.pv-pdp__color.is-active');
        var size = el.querySelector('.pv-pdp__size.is-active');
        var qtyEl = el.querySelector('[data-pv-qty]');
        var chosenColor = color ? color.getAttribute('data-color') : '';

        // seçili rengin görseli varsa sepette o görünsün
        var img = (p.images_by_color || {})[chosenColor];
        img = img && img.length ? img[0] : (p.card_image || gallery[0]);

        window.PVCart.add({
          handle: p.handle,
          title: p.title,
          price: p.price,
          image: img,
          color: chosenColor,
          size: size ? size.textContent.trim() : '',
          qty: Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1),
        });

        var label = add.textContent;
        add.textContent = 'Added ✓';
        setTimeout(function () {
          add.textContent = label;
        }, 1600);
      });
    }
  }

  /* ------------------------------------------------------------------- başlat */

  function boot() {
    var grids = document.querySelectorAll('[data-pv-catalog]:not([data-pv-done])');
    var chips = document.querySelectorAll('[data-pv-catalog-chips]:not([data-pv-done])');
    var tiles = document.querySelectorAll('[data-pv-catalog-tiles]:not([data-pv-done])');
    var detail = document.querySelectorAll('[data-pv-catalog-detail]:not([data-pv-done])');
    if (!grids.length && !chips.length && !tiles.length && !detail.length) return;

    load()
      .then(function (items) {
        grids.forEach(function (el) { el.setAttribute('data-pv-done', '1'); mountGrid(el, items); });
        chips.forEach(function (el) { el.setAttribute('data-pv-done', '1'); mountChips(el, items); });
        tiles.forEach(function (el) { el.setAttribute('data-pv-done', '1'); mountTiles(el, items); });
        detail.forEach(function (el) { el.setAttribute('data-pv-done', '1'); mountDetail(el, items); });
        if (window.PVBoot) window.PVBoot();
        document.dispatchEvent(new CustomEvent('petavis:catalog:ready'));
      })
      .catch(function (e) {
        // sessizce boş bırak — tema iskeletleri zaten görünüyor
        if (window.console) console.warn('[petavis] katalog:', e.message);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
